import { AppEnvironment } from './app-environment.type';

export const environment: AppEnvironment = {
  nestJSBackendUrl: 'https://api.kex.net/testing/benchmark-application',
  assessmentServiceUrl: 'https://api.kex.net/testing/assessment-service',
  tenantSlug: 'benchmark',
};
